<template>
  <v-app light class="white">
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import * as types from './store/mutation-types'

export default {
  name: 'app',
  components: {
  },
  data () {
    return {
    }
  },
  beforeCreate () {
    this.$store.commit(types.RECEIVE_PAGES, { pages: window.Kirby.pages })
    this.$store.commit(types.RECEIVE_SITE, { site: window.Kirby.site })
  },
  created () {
    window.addEventListener('resize', this.onResize, true)

    this.onResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.onResize, true)
  },
  methods: {
    onResize (event) {
      var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth
      this.$store.commit(types.UPDATE_APP, { field: 'tablet', value: windowWidth <= 960 })
      this.$store.commit(types.UPDATE_APP, { field: 'phone', value: windowWidth <= 480 })
    }
  }
}
</script>

<style lang="stylus">
@import 'https://use.typekit.net/icx6dyf.css'
@require '~vuetify/src/stylus/settings/_variables'
@require './assets/styles/base'

// FIXME figure out a way to put this in base.scss
@font-face
  font-family: 'BodyOfUsOne'
  font-weight: normal
  src: url("./assets/fonts/BodyOfUsOne.ttf")
.mt-100vh
  margin-top: 100vh
.pr-7
  padding-right: 120px
  @media $display-breakpoints.sm-and-down
    padding-right 60px
  @media $display-breakpoints.xs-only
    padding-right 30px
.pr-6
  padding-right 60px !important
  @media $display-breakpoints.sm-and-down
    padding-right 30px !important
  @media $display-breakpoints.xs-only
    padding-right 15px !important
.mt-6
  margin-top: 60px
  @media $display-breakpoints.sm-and-down
    margin-top 30px
  @media $display-breakpoints.xs-only
    margin-top 15px
  @media print
    margin-top 16px
.mb-6
  margin-bottom: 60px
  @media $display-breakpoints.sm-and-down
    margin-bottom 30px
  @media $display-breakpoints.xs-only
    margin-bottom 15px
  @media $display-breakpoints.xs-only
    .subpage-list &
      margin-bottom 28px
  @media print
    margin-bottom 16px
.ml-6
  margin-left: 60px
  @media $display-breakpoints.sm-and-down
    margin-left 30px
  @media $display-breakpoints.xs-only
    margin-left 15px

.pt-7
  padding-top: 120px
  @media $display-breakpoints.sm-and-down
    padding-top 90px
  @media $display-breakpoints.xs-only
    padding-top 40px
  @media print
    padding-top 60px
.mt-7
  margin-top: 120px
  @media $display-breakpoints.sm-and-down
    margin-top 90px
  @media $display-breakpoints.xs-only
    margin-top 40px
  @media print
    margin-top 60px
.mb-7
  margin-bottom: 120px
  @media $display-breakpoints.sm-and-down
    margin-bottom 90px
  @media $display-breakpoints.xs-only
    margin-bottom 40px
  @media print
    margin-bottom 40px
.pa-6
  padding: 60px
  @media $display-breakpoints.sm-and-down
    padding 30px
  @media $display-breakpoints.xs-only
    padding 15px
.pl-6
  padding-left: 60px !important
  @media $display-breakpoints.sm-and-down
    padding-left 30px !important
  @media $display-breakpoints.xs-only
    padding-left 15px !important
.text--title-medium
  font-size: 0.91rem
  line-height: 1.33
.text--title-italics-medium
  font-size: 0.72rem
  line-height: 1.23
.text--medium
  font-size: 0.83rem
  line-height: 1.2
.text--small
  font-size: 0.72rem
  line-height: 1.12
  a
    // NB: text small links
    background-position 0 0.9rem !important
.text--uppercase
  text-transform: uppercase
.max-width--1
  max-width: 900px
.subpage-list
  @extend .max-width--1
  margin-left: auto
  margin-right: 0
  li
    padding-left: 0
    position: relative
    > div
      padding-right: 175px
      @media $display-breakpoints.sm-and-down
        padding-right: 125px
    &:before
      display: none
    a
      position: absolute
      right: 0
      bottom: 10px
      font-size 0.72rem
      line-height 1.23
  .text--title-medium
    line-height 1
  .subpage--author
    line-height 1.1
    padding-top 2px
    padding-bottom 3px
*
  box-sizing: border-box
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
  -webkit-tap-highlight-color: transparent

html
  font-family: $font-family
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  font-size: $font-size
  color: $font-color
  @media $display-breakpoints.sm-and-down
    font-size $font-size-medium
  @media $display-breakpoints.xs-only
    font-size $font-size-small
  @media print
    font-size $font-size-print
    color black
    &.overflow-y-hidden
      overflow-y auto

.application.theme--light
  font-family: $font-family !important
  // background-color: black !important
  color: $font-color !important
  line-height: $line-height
  @media print
    color black !important
    background-color white !important

.container
  max-width: 1440px !important
  @media print
    padding 0 !important
    margin 0 !important

h1, h2, h3, h4, h5, h6
  font-weight: normal
  margin-bottom: 1rem

h3
  display block
  margin-top 0.5rem
  font-style italic
  font-size: 0.72rem;
  line-height: 1.23;
  @extends .text--title-italics-medium
  @extends .mb-6

small
  display: inline-block;
  font-size: 0.72rem;
  line-height: 1.12;

ul
  list-style-type: none
  padding: 0

li
  display: inline-block
  margin: 0

.underlined
  background-image linear-gradient(to right, $font-color 50%, transparent 50%)
  background-position 0 72%
  background-repeat repeat-x
  background-size 3px 1.5px

a,
a:visited
  color: $font-color !important
  text-decoration: none
  position relative
  @extends .underlined
  transition all 200ms
  &:hover
    background-size 100% 1.5px
    background-image linear-gradient(to right, $font-color 50%, $font-color 50%)
  &.no-underline
    background none !important
  @media print
    color black !important
    background none !important

h2, h1
  font-style italic
  display inline-block
  border-bottom 1px solid $font-color
  @extends .text--title-italics-medium
  @extends .text--uppercase
  @extends .mt-7

img
  max-width: 100%
  height: auto
p
  margin-bottom: 1rem
i, em
  font-style: italic
strong
  font-weight: normal
  @extend .text--title-italics-medium
  @extend i
blockquote
  padding: 0 1rem
  margin-bottom: 1rem
  width 90%
  margin-right 0
  margin-left auto
  font-style italic
hr
  border-color $font-color
  border-top none !important
  margin 10px 0
  border-style solid
  @media print
    border-color black
figure
  @extend .max-width--1
  margin-left: auto
  margin-right: 0
  @extend .mt-6
  @extend .mb-6
  text-align: right
  figcaption
    @extend .text--small
    text-align left
  audio
    width 100%
figure.video
  height: 0
  padding-bottom: 56.25%
  position: relative
  background-color: lightgray
  iframe
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
ol
  li
    display: list-item
    position: relative
ul
  li
    display: list-item
    padding-left: 0.75rem
    position: relative
    &:before
      content: '•'
      position: absolute
      left: 0
    ul, ol
      margin-bottom: 1rem
.footnote-ref
  background none !important
.footnotes
  @extend .text--small
  hr
    @extends .mt-7
  ol
    list-style none
    counter-reset item
    padding-left 1rem
    &:before
      // TODO make configurable?
      content "NOTES"
      display block
      margin-left -1rem
      margin-top 0.5rem
      font-style italic
      @extends .text--title-italics-medium
      @extends .mb-6
    li
      counter-increment item
      padding-left 0
      margin-left -1rem
      &:before
        display none
      p:first-child:before
        margin-right 10px
        content counter(item)
        display inline-block
        position static
  .footnote-backref
    display none

.full--height
  height: 100vh
section
  position: relative

.icon
  display inline-block
  background-position center
  background-repeat no-repeat
  background-size contain

  &.icon-arrow
    background-image url('./assets/images/arrow.svg')

  &.icon-close
    background-image url('./assets/images/close.svg')
    height 0.77rem
    width 0.77rem

  &.icon-hamburger
    background-image url('./assets/images/hamburger.svg')
    height 0.94rem
    width 0.94rem

  &.icon-twitter
    background-image url('./assets/images/twitter.svg')
    height 1rem
    width 1rem

  &.icon-facebook
    background-image url('./assets/images/facebook.svg')
    height 1rem
    width 1rem
    margin-left 10px
    margin-right 13px

  &.icon-print
    background-image url('./assets/images/print.svg')
    height 1rem
    width 1rem

  &.icon-document
    background-image url('./assets/images/document.svg')
    height 1rem
    width 1rem

@media print
  // print reset https://www.matuzo.at/blog/i-totally-forgot-about-print-style-sheets/
  // https://github.com/h5bp/html5-boilerplate/blob/master/dist/css/style.css
  *,
  *::before,
  *::after {
    background: transparent !important;
    color: #000 !important;
    /* Black prints faster */
    box-shadow: none !important;
    text-shadow: none !important;
  }

  a,
  a:visited {
    text-decoration: underline;
  }

  a[href]::after {
    content: " (" attr(href) ")";
    word-break: break-all;
  }

  abbr[title]::after {
    content: " (" attr(title) ")";
    word-break: break-all;
  }

  /*
   * Don't show links that are fragment identifiers,
   * or use the `javascript:` pseudo protocol
   */
  a[href^="#"]::after,
  a[href^="javascript:"]::after {
    content: "";
  }

  pre {
    white-space: pre-wrap !important;
  }

  pre,
  blockquote {
    page-break-inside: avoid;
  }

  /*
   * Printing Tables:
   * https://web.archive.org/web/20180815150934/http://css-discuss.incutio.com/wiki/Printing_Tables
   */
  thead {
    display: table-header-group;
  }

  tr,
  img {
    page-break-inside: avoid;
  }

  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    page-break-after: avoid;
  }

@page
  size: A4;   /* auto is the initial value */
  /* this affects the margin in the printer settings */
  margin 12mm 20mm 12mm 20mm
</style>
